import React from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'

// routes
import { withRouter } from 'react-router-dom'

// Sweet alert
import Swal from 'sweetalert2'

// services
import { deleteByIdOferta } from '../../Services/ofertaService'

const ItemOferta = ({ oferta, history, setIsLoad, deleteOferta }) => {
    const EliminarOfertaSubmit = (id) => {
        Swal.fire({
            title: 'Estas seguro de eliminar?',
            text: 'Una oferta eliminada no se puede recuperar!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Eliminar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                // consulta a la api para eliminar
                deleteByIdOferta(id)
                    .then((res) => {
                        Swal.fire(
                            'Eliminado!',
                            'La oferta fue eliminada.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    return (
        <tr>
            <th scope="row">{oferta.id}</th>
            <td>{oferta.nombre}</td>
            <td>{oferta.articulo.nombre}</td>
            <td>{oferta.fechaFinOferta.split('T')[0]}</td>
            <td>
                <b>%</b> {oferta.porcentajeDescuento}
            </td>
            <td>
                <b>$</b> {oferta.precioFinal}
            </td>
            <td>{oferta.promocionCantidad}</td>
            <td>
                <button
                    className="btn text-danger"
                    onClick={() => {
                        history.push(`/edit-oferta/${oferta.id}`, {
                            oferta: oferta,
                        })
                    }}
                >
                    <FontAwesomeIcon icon={faEdit} /> Editar
                </button>
                <button
                    className="btn text-primary"
                    onClick={() => EliminarOfertaSubmit(oferta.id)}
                >
                    <FontAwesomeIcon icon={faTrash} /> Eliminar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemOferta)
